import api from '@/services/apiService';

export interface PasswordUpdateResponse {
  success: boolean;
  message?: string;
}

const updateClientPassword = async (payload: {
  current_password: string;
  new_password: string;
  confirm_new_password: string;
}): Promise<PasswordUpdateResponse> => {
  const response = await api.put(`/client/password`, payload);
  return response.data;
};

export { updateClientPassword };
